var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"w-full rounded-md border bg-white overflow-hidden",staticStyle:{"height":"90vh"}})
}
var staticRenderFns = []

export { render, staticRenderFns }